// Generated by scripts/build-l10n.mjs from TrailBivvyIOS Tools/l10n/languages.json — do not edit by hand.
// English is the source language; the others are the 33 translations of the iOS app (machine-assisted, iOS
// DECISION.md #19). Run `npm run l10n` after the iOS strings change.

export interface LanguageInfo {
  /** BCP 47 code, as in the iOS catalog (also the locale file name). */
  readonly code: string;
  readonly englishName: string;
  /** Name in the language itself, for the language picker. */
  readonly nativeName: string;
  /** Right-to-left script (sets <html dir="rtl">). */
  readonly rtl: boolean;
}

export const supportedLanguages = [
  { code: 'en', englishName: 'English', nativeName: 'English', rtl: false },
  { code: 'fr', englishName: 'French', nativeName: 'Français', rtl: false },
  { code: 'de', englishName: 'German', nativeName: 'Deutsch', rtl: false },
  { code: 'it', englishName: 'Italian', nativeName: 'Italiano', rtl: false },
  { code: 'es', englishName: 'Spanish (Spain/international)', nativeName: 'Español', rtl: false },
  { code: 'pt-PT', englishName: 'Portuguese (Portugal)', nativeName: 'Português (Portugal)', rtl: false },
  { code: 'pt-BR', englishName: 'Portuguese (Brazil)', nativeName: 'Português (Brasil)', rtl: false },
  { code: 'nl', englishName: 'Dutch', nativeName: 'Nederlands', rtl: false },
  { code: 'pl', englishName: 'Polish', nativeName: 'Polski', rtl: false },
  { code: 'cs', englishName: 'Czech', nativeName: 'Čeština', rtl: false },
  { code: 'sk', englishName: 'Slovak', nativeName: 'Slovenčina', rtl: false },
  { code: 'sl', englishName: 'Slovenian', nativeName: 'Slovenščina', rtl: false },
  { code: 'hr', englishName: 'Croatian', nativeName: 'Hrvatski', rtl: false },
  { code: 'hu', englishName: 'Hungarian', nativeName: 'Magyar', rtl: false },
  { code: 'ro', englishName: 'Romanian', nativeName: 'Română', rtl: false },
  { code: 'bg', englishName: 'Bulgarian', nativeName: 'Български', rtl: false },
  { code: 'el', englishName: 'Greek', nativeName: 'Ελληνικά', rtl: false },
  { code: 'tr', englishName: 'Turkish', nativeName: 'Türkçe', rtl: false },
  { code: 'sv', englishName: 'Swedish', nativeName: 'Svenska', rtl: false },
  { code: 'nb', englishName: 'Norwegian Bokmål', nativeName: 'Norsk bokmål', rtl: false },
  { code: 'da', englishName: 'Danish', nativeName: 'Dansk', rtl: false },
  { code: 'fi', englishName: 'Finnish', nativeName: 'Suomi', rtl: false },
  { code: 'is', englishName: 'Icelandic', nativeName: 'Íslenska', rtl: false },
  { code: 'ca', englishName: 'Catalan', nativeName: 'Català', rtl: false },
  { code: 'ru', englishName: 'Russian', nativeName: 'Русский', rtl: false },
  { code: 'uk', englishName: 'Ukrainian', nativeName: 'Українська', rtl: false },
  { code: 'ja', englishName: 'Japanese', nativeName: '日本語', rtl: false },
  { code: 'ko', englishName: 'Korean', nativeName: '한국어', rtl: false },
  { code: 'zh-Hans', englishName: 'Chinese (Simplified)', nativeName: '简体中文', rtl: false },
  { code: 'zh-Hant', englishName: 'Chinese (Traditional)', nativeName: '繁體中文', rtl: false },
  { code: 'he', englishName: 'Hebrew', nativeName: 'עברית', rtl: true },
  { code: 'ar', englishName: 'Arabic', nativeName: 'العربية', rtl: true },
  { code: 'hi', englishName: 'Hindi', nativeName: 'हिन्दी', rtl: false },
  { code: 'id', englishName: 'Indonesian', nativeName: 'Bahasa Indonesia', rtl: false },
] as const satisfies readonly LanguageInfo[];

export type LanguageCode = (typeof supportedLanguages)[number]['code'];

export const sourceLanguage: LanguageCode = 'en';

/** Where the strings came from. */
export const l10nSource = { repository: 'TrailBivvyIOS', commit: 'b2c21b3', keys: 2089 } as const;
